<script>

    import * as echarts from 'echarts'
    import Moment from 'moment'
    import { onMount } from 'svelte'

    import GraphicsService from '../$services/graphics.service'

    export let dateStart = null
    export let dateEnd = null

    let chartContainer
    let chart
    let ready = false
    let geoReady = false

    $: periodLabel = dateStart && dateEnd
        ? `${Moment(dateStart).locale('es').format('D MMM YYYY')} - ${Moment(dateEnd).locale('es').format('D MMM YYYY')}`
        : ''

    onMount(async () => {
        const geoMexico = await fetch('/mexico.geojson').then((res) => res.json())
        echarts.registerMap('mexico', geoMexico)
        geoReady = true

        chart = echarts.init(chartContainer)
        ready = true

        const resize = () => chart.resize()
        window.addEventListener('resize', resize)

        return () => {
            window.removeEventListener('resize', resize)
            chart.dispose()
            chart = null
            ready = false
        }
    })

    $: if (ready && geoReady) load(dateStart, dateEnd)

    async function load(start, end) {
        if (!chart || !start || !end) return

        const res = await GraphicsService.getShipmentsStates({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        const data = res?.data ?? []
        const max = data.length ? Math.max(...data.map((item) => item.value || 0), 1) : 1

        chart.setOption({
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    const value = Number.isFinite(params.value) ? params.value : 0
                    return `${params.name}: ${value}`
                },
            },
            visualMap: {
                min: 0,
                max,
                left: 16,
                bottom: 24,
                orient: 'vertical',
                text: ['Más envíos', 'Menos envíos'],
                textStyle: {
                    color: '#6b7280',
                    fontSize: 12,
                },
                inRange: {
                    color: ['#e8f8ef', '#86efac', '#22c55e', '#098E37'],
                },
                calculable: false,
                itemWidth: 12,
                itemHeight: 120,
            },
            series: [
                {
                    name: 'Envíos',
                    type: 'map',
                    map: 'mexico',
                    nameProperty: 'NOMGEO',
                    roam: true,
                    scaleLimit: { min: 0.8, max: 8 },
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 1,
                        areaColor: '#f3f4f6',
                    },
                    emphasis: {
                        label: { show: true, color: '#1a1a1a' },
                        itemStyle: {
                            areaColor: '#16a34a',
                        },
                    },
                    data,
                },
            ],
        }, true)
    }

</script>

<style>
    .card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
        padding: 1.35rem 1.5rem;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .header {
        margin-bottom: 1rem;
    }

    .title {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0 0 0.25rem;
        line-height: 1.2;
    }

    .period {
        font-size: 0.85rem;
        color: #9e9e9e;
        margin: 0;
        text-transform: capitalize;
    }

    .map {
        width: 100%;
        height: 280px;
        flex: 1;
        min-height: 240px;
    }
</style>

<div class="card">
    <div class="header">
        <h3 class="title">Envíos por estado (mapa)</h3>
        {#if periodLabel}
            <p class="period">{ periodLabel }</p>
        {/if}
    </div>

    <div bind:this={chartContainer} class="map"></div>
</div>
